module.exports = __webpack_public_path__ + "static/logo-e29a7249a80474bdd658665d581c7236.svg";